/*******************************************************
 *                                                     *
 * ----------------- EVENT HANDLERS ------------------ *
 *                                                     *
 *******************************************************/

import { identify, track } from './segmetTracker';
import { EVENT_NAMES } from './constants';
import {
    OrderProperties,
    LooseObject,
    MarketingOptInProperties,
    TrialProductProperties,
} from './types';

// --- Page Track Event Handlers //
export function handleTrialSignupStartedEvent(product_details: TrialProductProperties): void {
    track(EVENT_NAMES.PAGE.checkout.trial.started, {
        ...product_details,
    });
}

export function handleTrialSignupStepEvent(product_details: TrialProductProperties): void {
    track(EVENT_NAMES.PAGE.checkout.trial.step_viewed, {
        ...product_details,
    });
}

export function handleTrialOrderCompletedEvent(order_properties: TrialProductProperties): void {
    track(EVENT_NAMES.CTA.checkout.trial.order_completed, {
        ...order_properties,
    });
}

export function handleCheckoutStepViewedEvent(chcekout_properties: OrderProperties): void {
    track(EVENT_NAMES.PAGE.checkout.step_viewed, {
        ...chcekout_properties,
    });
}

export function handleCheckoutStartedEvent(chcekout_properties: OrderProperties): void {
    track(EVENT_NAMES.PAGE.checkout.started, {
        ...chcekout_properties,
    });
}

// --- CTA Click Event Handlers //
export function handleCtaClickEvent({ target }: Event): void {
    const { innerText, href, hostname, pathname } = target as HTMLAnchorElement;
    const targetName = (target as HTMLElement).getAttribute('data-cta-name');

    track(EVENT_NAMES.CTA.generic, {
        cta_name: targetName,
        cta_text: innerText,
        cta_target_url: href,
        cta_target_domain: hostname,
        cta_target_path: pathname,
    });
    target?.removeEventListener('click', handleCtaClickEvent);
}

export function handleTrialSignupStepCompletedClickEvent(
    product_details: TrialProductProperties
): void {
    track(EVENT_NAMES.CTA.checkout.trial.step_completed, {
        ...product_details,
    });
}

export function handleCheckoutStepCompletedClickEvent(chcekout_properties: OrderProperties): void {
    track(EVENT_NAMES.CTA.checkout.step_completed, {
        ...chcekout_properties,
    });
}

// --- Form Event Handlers //
export function handleTrialValidCreditCardEvent(product_details: TrialProductProperties): void {
    track(EVENT_NAMES.FORM.input.trial.credit_card, {
        ...product_details,
    });
}

export function handleCheckoutPaymentInfoEnteredEvent(chcekout_properties: OrderProperties): void {
    track(EVENT_NAMES.FORM.input.checkout.payment_info, {
        ...chcekout_properties,
    });
}

export function handleCheckoutMarketingOptInSubmitEvent(
    properties: MarketingOptInProperties
): void {
    track(EVENT_NAMES.FORM.submit.marketing, {
        ...properties,
    });
}

export function handleMarketingOptInSubmitEvent({ target }: Event): void {
    const formElement = target as HTMLFormElement;

    const type = formElement.getAttribute('data-form-name');
    let properties: LooseObject = {
        source: formElement.getAttribute('data-form-source'),
        source_detail: formElement.getAttribute('data-form-source-detail'),
    };
    const optInCheckbox: HTMLInputElement | null = formElement.querySelector(
        "input[type='checkbox'][id='optIn']"
    );

    switch (type) {
        case 'marketing-opt-in-email':
            properties.email = (<HTMLInputElement>(
                (<any>formElement.querySelector("input[type='email']"))
            ))?.value;
            properties.is_email_opt_in = true;
            break;
        case 'marketing-opt-in-sms':
            properties.phone = (<HTMLFormElement>(
                (<any>formElement.querySelector("input[type='tel']"))
            ))?.value;
            properties.is_sms_opt_in = true;
            break;
        default:
            break;
    }

    if (optInCheckbox && !optInCheckbox.checked) {
        return;
    } else {
        if (properties.email) {
            identify(properties.email, { email: properties.email });
        }
        track(EVENT_NAMES.FORM.submit.marketing, {
            ...properties,
        });
    }
}

// --- Video Event Handlers // TODO Adjust to typescript
// export function handleVideoPlayEvent(element, event, properties): void {
//     element.addEventListener("play", () => {
//         track(event, {
//             total_length: parseInt(element.duration * 1000),
//             ...properties,
//         });
//     });
// }
// export function handleVideoPauseEvent(element, event, properties): void {
//     element.addEventListener("pause", () => {
//         const total_length = element.duration;
//         const currentTime = element.currentTime;
//         const currentTimePercentage = parseInt(
//             (total_length / currentTime) * 100
//         );
//         /* Track as Completed event only if video paused above 75% and bellow 100%
//           Note: Bellow 100% because if user continues playing de video and it ends
//           DOM automattically executes pause event again creating a duplicate event*/
//         if (currentTimePercentage >= 75 && currentTimePercentage < 100) {
//             track(event, {
//                 position: parseInt(currentTime * 1000),
//                 completed_percent: currentTimePercentage / 100,
//                 ...properties,
//             });
//         }
//     });
// }
// export function handleVideoEndedEvent(element, event, properties): void {
//     element.addEventListener("ended", () => {
//         track(event, {
//             position: parseInt(element.currentTime * 1000),
//             completed_percent: 1,
//             ...properties,
//         });
//     });
// }
